import { type ComponentProps, forwardRef, type ReactNode } from 'react'
import { clsx } from 'clsx'
import { motion } from 'motion/react'
import { PlusInCircleIcon } from 'ui/src/icons/PlusInCircleIcon'
import { tokens } from 'ui/src/theme/tokens.css'
import { framerTransitions } from 'ui/src/theme/transitions'
import { infoButton, infoPlusIcon } from './InfoButton.css'

type Props = {
  children: ReactNode
} & ComponentProps<typeof motion.button>

export const InfoButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, className, onClick, ...forwardedProps }, ref) => {
    return (
      <motion.button
        ref={ref}
        className={clsx(infoButton, className)}
        onClick={onClick}
        whileHover={{ backgroundColor: tokens.legacyColors.surfaceOpaquePrimary }}
        transition={framerTransitions.defaultHover}
        {...forwardedProps}
      >
        {children}
        <PlusInCircleIcon color={tokens.legacyColors.fillOpaqueSecondary} size="1.5rem" className={infoPlusIcon} />
      </motion.button>
    )
  },
)
InfoButton.displayName = 'InfoButton'
